// extracted by mini-css-extract-plugin
export default {"HeaderSection":"Header_HeaderSection__E4xon","HeaderSectionReduction":"Header_HeaderSectionReduction__Wl57D","HeaderDisc":"Header_HeaderDisc__08nee"};